export const EXECUTION_ACTIONS = {
  view: 'view',
  download_input: 'download_input',
  download_output: 'download_output',
  download_report: 'download_report',
  cancel: 'cancel',
  reprocess_dry_run: 'reprocess_dry_run',
  reprocess: 'reprocess',
} as const;

export const DEFAULT_PAGINATION_SETTINGS = {
  page: 1,
  pageSize: 25,
  ordering: '-created',
};
